<template>
  <div>
    <h1>OH SHIT!!</h1>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
